import { inject, Injectable, signal } from '@angular/core';
import { ApiGatewayService, SakooResponse } from './api-gateway.service';
import { Observable, tap, map } from 'rxjs';

export interface Rate {
  currency_code: string;
  rate_average: string;
  rate_from: string;
  rate_id: number;
  rate_to: string;
  source: string;
  status: string;
  updated_at: string;
  value_date: string;
}

export interface ApproveRatePayload {
  rate_average: number;
  rate_from: number;
  rate_id: number;
  rate_to: number;
  source: string;
}

@Injectable({
  providedIn: 'root',
})
export class RatesService {
  private readonly api = inject(ApiGatewayService);

  // Signal reactivo para el historial de tasas
  private readonly _rates = signal<Rate[]>([]);
  public readonly rates = this._rates.asReadonly();

  /**
   * Obtiene el historial de tasas.
   * Realiza la llamada HTTP al backend y actualiza el Signal.
   */
  getRatesHistory(): Observable<Rate[]> {
    return this.api.get<SakooResponse<Rate[]>>('/api/backoffice/rates/history').pipe(
      map((res) => {
        if (res.code !== 1000) {
          throw new Error(res.message || 'Error al obtener el historial de tasas del servidor.');
        }
        return res.data;
      }),
      tap((data) => {
        this._rates.set(data);
      })
    );
  }

  /**
   * Modifica y aprueba una tasa de cambio.
   */
  approveRate(payload: ApproveRatePayload): Observable<SakooResponse<Rate>> {
    return this.api.put<SakooResponse<Rate>>('/api/backoffice/rates/approve', payload).pipe(
      map((res) => {
        if (res.code !== 1000) {
          throw new Error(res.message || 'Error al aprobar la tasa de cambio en el servidor.');
        }
        return res;
      })
    );
  }
}
